import { Field } from "react-final-form";
import { Fieldset } from "../../../../components/inputs/final_form/Fieldset";
import { SelectInput } from "../../../../components/inputs/final_form/SelectInput";
import { Switch } from "../../../../components/inputs/final_form/Switch";
import { TextInput } from "../../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../../components/LoadingButton";
import { required } from "../../../../util/validators";
import { AdministrateSelectInput } from "../../../components/inputs/AdministrateSelectInput";
import { PayorSelector } from "../../../../components/inputs/final_form/PayorSelector";

const submissionAttemptOptions = [
  { value: "", label: "Do not change" },
  { value: true, label: "Successful" },
  { value: false, label: "Unsuccessful" },
];

const payorSwitchOptions = [
  { value: "", label: "Do not change" },
  { value: "configured_payor", label: "Switch to configured payor" },
  { value: "availity_response", label: "Switch to payor from Availity response" },
];

export const AvailityErrorRuleForm = ({ handleSubmit, submitting, values }) => (
  <>
    <Fieldset legend="Match Conditions">
      <Field component={TextInput} label="HTTP Response Code" name="httpResponseCode" placeholder="400, 502, 4xx, or 5xx" />
      <Field component={TextInput} label="Availity Status Code" name="availityStatusCode" placeholder="CT" />
      <Field component={PayorSelector} isClearable label="Payor" name="payorId" valueSelector="id" />
      <Field component={TextInput} label="Message Regex" name="messageRegex" />
    </Fieldset>

    <Fieldset legend="Outcomes">
      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/enums/prior_auth_statuses.json"
        label="New Status"
        name="newStatus"
        labelKey="label"
      />
      <Field component={TextInput} label="Comment Text" name="commentText" rows={5} type="textarea" />
      {values.commentText && <Field component={Switch} label="Public Comment" name="commentPublic" type="checkbox" />}
      <Field component={SelectInput} label="Submission Attempt" name="submissionAttemptSuccessful" options={submissionAttemptOptions} />
      <Field component={SelectInput} label="Payor Switch" name="payorSwitchMode" options={payorSwitchOptions} />
      {values.payorSwitchMode === "configured_payor" && (
        <Field component={PayorSelector} isClearable label="New Payor" name="newPayorId" valueSelector="id" validate={required} required />
      )}
      {values.payorSwitchMode === "availity_response" && (
        <p className="text-muted small">The payor will be resolved from the Availity response when this rule is applied.</p>
      )}
    </Fieldset>

    <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
      Save
    </LoadingButton>
  </>
);
